import {
	ClientDescriptor,
	createHooks,
	migrations,
	type UserInfo,
} from "@trip/verdant";
export type * from "@trip/verdant";
import { EventEmitter } from "eventemitter3";

export type Presence = {};

// should match server
export interface Profile {
	id: string;
	name: string;
	imageUrl: string | null;
}

export type Participant = UserInfo<Profile, Presence>;

export const hooks = createHooks<Presence, Profile>();

export const clientDescriptor = new ClientDescriptor({
	namespace: "trip",
	migrations,
	sync: {
		initialPresence: {
			emoji: "",
		},
		defaultProfile: { name: "" },
		authEndpoint: "https://trip-api.pmlife.top/auth/sync",
		autoStart: true
	},
});



// these are some helpers I like to use. You can delete them if you want.

async function exposeClientOnWindowForDebug() {
	const client = await clientDescriptor.open();
	(window as any).client = client;
}

export const clientEvent = new EventEmitter();

async function registerUndoKeybinds() {
	const client = await clientDescriptor.open();



	client.sync.setPullInterval(10 * 1000)



	client.subscribe('operation', (operation) => {

		if (operation.oid) {
			const [entity, id] = operation.oid.split('/');
			if (entity && id) {
				clientEvent.emit(`${entity}/onRecordChange`, { id, ...operation })
			} else {
				console.info(operation)
			}

		}

	})




	document.addEventListener("keydown", async (e) => {
		if (e.key === "z" && (e.ctrlKey || e.metaKey) && !e.shiftKey) {
			e.preventDefault();
			const result = await client.undoHistory.undo();
			if (!result) {
				console.info("Nothing to undo");
			}
		}
		if (
			(e.key === "y" && (e.ctrlKey || e.metaKey)) ||
			(e.key === "z" && e.shiftKey && (e.ctrlKey || e.metaKey))
		) {
			e.preventDefault();
			const result = await client.undoHistory.redo();
			if (!result) {
				console.info("Nothing to redo");
			}
		}
	});
}



exposeClientOnWindowForDebug();
registerUndoKeybinds();
